import { request } from "../../api";

export type NetworkAccessRequestStatus =
  | "pending"
  | "investigating"
  | "approved"
  | "rejected"
  | "expired"
  | "cancelled";

export type NetworkAccessRequestDuration = "permanent" | "temporary";

export interface NetworkAccessRequestRow {
  id: string;
  status: NetworkAccessRequestStatus;
  reason: string;
  requested_duration: NetworkAccessRequestDuration;
  requested_hours: number | null;
  enrollee_full_name: string;
  enrollee_phone: string;
  device_id: string;
  device_uid: string;
  decided_by_email: string | null;
  decided_at: string | null;
  decision_note: string;
  grants_active_count: number;
  created_at: string;
}

export interface NetworkAccessRequestPage {
  total: number;
  limit: number;
  offset: number;
  pending_total: number;
  items: NetworkAccessRequestRow[];
}

export interface InvestigationPayload {
  request: {
    id: string;
    status: NetworkAccessRequestStatus;
    reason: string;
    requested_duration: NetworkAccessRequestDuration;
    requested_hours: number | null;
    enrollee_full_name: string;
    enrollee_phone: string;
    device_id: string;
    device_uid: string;
    created_at: string;
    decided_at: string | null;
    decision_note: string;
  };
  lookback_hours: number;
  denied_url_pools: {
    url_pool_id: string;
    kind: "domain" | "ipv4" | "ipv6" | "cidr";
    value: string;
    vuln_status: string;
    vuln_severity: string;
    blocked_count: number;
    last_blocked_at: string;
  }[];
}

export interface ApproveBody {
  url_pool_ids: string[];
  duration: NetworkAccessRequestDuration;
  duration_hours?: number | null;
  note?: string;
}

function qs(params: object): string {
  const sp = new URLSearchParams();
  for (const [k, v] of Object.entries(params) as [string, unknown][]) {
    if (v === undefined || v === "" || v === null) continue;
    sp.append(k, String(v));
  }
  const s = sp.toString();
  return s ? `?${s}` : "";
}

export const networkAccessRequestsApi = {
  list: (filters: { status?: NetworkAccessRequestStatus; limit?: number; offset?: number } = {}) =>
    request<NetworkAccessRequestPage>(
      `/api/admin/v1/network-access-requests/${qs(filters)}`,
    ),
  investigation: (id: string, hours = 24) =>
    request<InvestigationPayload>(
      `/api/admin/v1/network-access-requests/${id}/investigation/?hours=${hours}`,
    ),
  approve: (id: string, body: ApproveBody) =>
    request<{ request: NetworkAccessRequestRow; grants_created: number }>(
      `/api/admin/v1/network-access-requests/${id}/approve/`,
      { method: "POST", json: body },
    ),
  reject: (id: string, note: string) =>
    request<NetworkAccessRequestRow>(
      `/api/admin/v1/network-access-requests/${id}/reject/`,
      { method: "POST", json: { note } },
    ),
};
